import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isOpen", "theme", "style", "overlayClassName", "portalClassName", "portalRef", "disableScroll", "portalProps", "onClose", "closeOptions"];
import React, { forwardRef, useRef } from 'react';
import { Transition } from 'react-transition-group';
import { cnBem, combineRefs } from '@carnica/utils';
import { useKeys } from '@carnica/utils/hooks';
import { EKeyCodes } from '@carnica/utils/types';
import { ThemedPortal } from '@carnica/ui-kit';
import { useBlockScroll } from "../../../../hooks/useBlockScroll";
import styles from "./styles.pcss";
import { ModalContent } from "./ModalContent";
var cnModal = cnBem('modal', styles);
var defaultCloseOptions = {
  overlay: true,
  button: true,
  escape: true
};
export var Modal = /*#__PURE__*/forwardRef(function (props, ref) {
  var isOpen = props.isOpen,
    theme = props.theme,
    style = props.style,
    overlayClassName = props.overlayClassName,
    portalClassName = props.portalClassName,
    portalRef = props.portalRef,
    _props$disableScroll = props.disableScroll,
    disableScroll = _props$disableScroll === void 0 ? true : _props$disableScroll,
    portalProps = props.portalProps,
    onClose = props.onClose,
    _props$closeOptions = props.closeOptions,
    closeOptions = _props$closeOptions === void 0 ? defaultCloseOptions : _props$closeOptions,
    otherProps = _objectWithoutProperties(props, _excluded);
  var wrapperRef = useRef(null);
  var overlayRef = useRef(null);
  useKeys(_defineProperty({}, EKeyCodes.Escape, function (e) {
    return isOpen && closeOptions.escape && (onClose === null || onClose === void 0 ? void 0 : onClose(e));
  }));
  useBlockScroll(disableScroll && isOpen);
  return /*#__PURE__*/React.createElement(Transition, {
    in: isOpen,
    nodeRef: wrapperRef,
    timeout: 300,
    unmountOnExit: true
  }, function (animate) {
    return /*#__PURE__*/React.createElement(ThemedPortal, _extends({}, portalProps !== null && portalProps !== void 0 ? portalProps : {}, {
      "aria-modal": true,
      className: cnModal(null, [portalClassName]),
      ref: combineRefs([wrapperRef, portalRef]),
      role: "dialog",
      style: {
        zIndex: typeof (style === null || style === void 0 ? void 0 : style.zIndex) === 'number' ? style.zIndex : 1
      },
      theme: theme
    }), /*#__PURE__*/React.createElement("div", {
      "aria-hidden": "true",
      className: cnModal('overlay', {
        animate: animate
      }, overlayClassName),
      ref: overlayRef
    }, /*#__PURE__*/React.createElement(ModalContent, _extends({
      animate: animate,
      closeOptions: closeOptions,
      isOpen: isOpen,
      onClose: onClose,
      overlayRef: overlayRef,
      ref: ref,
      style: style
    }, otherProps))));
  });
});